import { SendMessageInterface } from 'constants/interfaces';
import * as Yup from 'yup';

type TranslateFunction = (key: string, params?: Record<string, string>) => string;

export const sendMessageInitialValues: SendMessageInterface = {
	message: '',
	receiverId: null,
	attachmentType: 'text',
};

export const sendMessageSchema = (translate: TranslateFunction) =>
	Yup.object().shape({
		message: Yup.string()
			.trim()
			.required(translate('Validation.required', { field: 'Message' })),
		receiverId: Yup.string().required(translate('Validation.required', { field: 'Receiver Id' })),
		attachmentType: Yup.string().required(
			translate('Validation.required', { field: 'Attachment Type' }),
		),
	});
